<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4.5 17V4.6c0-.6.5-1.1 1.1-1.1h6.8c.6 0 1.1.5 1.1 1.1V17"/><path d="M13.5 8.4h1.9c.6 0 1.1.5 1.1 1.1V17M3 17h14"/><path d="M7.2 6.6h1.2M11 6.6h1.2M7.2 9.8h1.2M11 9.8h1.2M8.4 17v-3.4h2.4V17"/></svg>
</template>
